import { IconProps } from './types';

const CiuAllocationIcon = (props: IconProps) => {
  const { width = '54', height = '54', fillColor = 'var(--blue-bg)' } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="27" cy="27" r="27" fill={fillColor} />
      <g clipPath="url(#clip0_13305_115924)">
        <path
          d="M24.3333 26.9987C27.2789 26.9987 29.6667 24.6109 29.6667 21.6654C29.6667 18.7198 27.2789 16.332 24.3333 16.332C21.3878 16.332 19 18.7198 19 21.6654C19 24.6109 21.3878 26.9987 24.3333 26.9987Z"
          fill="#0276FE"
        />
        <path
          d="M24.8003 29.6787C21.1603 29.5454 13.667 31.3587 13.667 34.9987V37.6654H26.387C23.0937 33.9854 24.747 29.8121 24.8003 29.6787Z"
          fill="#0276FE"
        />
        <path
          d="M36.9067 35.0267C37.3867 34.24 37.6667 33.32 37.6667 32.3333C37.6667 29.3867 35.28 27 32.3333 27C29.3867 27 27 29.3867 27 32.3333C27 35.28 29.3867 37.6667 32.3333 37.6667C33.32 37.6667 34.24 37.3733 35.0267 36.9067L38.4533 40.3333L40.3333 38.4533L36.9067 35.0267ZM32.3333 35C30.8667 35 29.6667 33.8 29.6667 32.3333C29.6667 30.8667 30.8667 29.6667 32.3333 29.6667C33.8 29.6667 35 30.8667 35 32.3333C35 33.8 33.8 35 32.3333 35Z"
          fill="#0276FE"
        />
      </g>
      <defs>
        <clipPath id="clip0_13305_115924">
          <rect width="32" height="32" fill="white" transform="translate(11 11)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CiuAllocationIcon;
